module.exports = __webpack_public_path__ + "static/img/mengguo_logo.ba3deeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nav/mengguo_logo.png
// module id = 337
// module chunks = 13